import numericFunction from "../../utils/NumericFunction";

export const findMinMaxTimeStamp = (data: {
  locationsData: { timestamp: number | string }[]
}[]): [number | null, number | null] => {

  const timestamps = data.data.flatMap(object => object.locationsData.map(({timestamp}) => parseFloat(timestamp)));
  console.log(timestamps)
  const [min, max] = [Math.min(...timestamps), Math.max(...timestamps)];
  return [min, max];
};


interface VideoData {
  LAT_A: string;
  LONG_A: string;
  id: string;
  name: string;
  pelak: string;
  type: string;
}

const makeArrayOfArraysOfObjects = (minTimeStamp, maxTimeStamp, data, stepInMilliSeconds = 20) => {

  const legendary = [];
  let temMin = minTimeStamp;
  let tempMax = minTimeStamp + stepInMilliSeconds;

  const max = (maxTimeStamp === Infinity || (maxTimeStamp === -Infinity)) ? 0 : maxTimeStamp;
  const min = (minTimeStamp === Infinity || (minTimeStamp === -Infinity)) ? 0 : minTimeStamp;

  [...Array(Math.ceil((max - min) / stepInMilliSeconds))].forEach(step => {
    const innerArray = [];
    data.data.forEach(object => {

      debugger
      object.locationsData.forEach(ld => {
        debugger
        if (temMin <= +ld.timestamp && +ld.timestamp < tempMax) {
          innerArray.push({
            LAT_A: ld.LAT_A,
            LONG_A: ld.LONG_A,
            id: ld.id,
            name: ld.name,
            pelak: ld.pelak,
            type: ld.type,
            timestamp: ld.timestamp,
          })
        }
      })
      debugger

    })
    temMin += stepInMilliSeconds
    tempMax += stepInMilliSeconds
    console.log(temMin, tempMax)
    // dont need To stop and Check if it is touch Max
    // because foreach knows how many Times itrate
    legendary.push(innerArray);
  })


  console.log(legendary)
  return [[{
    LAT_A: "0.0000000", LONG_A: "0.0000000", id: "11001", name: "راننده تاکسی 3", pelak: "54236ج59", type: "taxi",
  },]];
}
export const videoLikeArray = (data: {
  locationsArchive: { timestamp: number }[]
}[], stepInMilliSeconds): VideoData[][] => {
  const [minTimeStamp, maxTimeStamp] = findMinMaxTimeStamp(data);
  debugger
  const newArray = makeArrayOfArraysOfObjects(minTimeStamp, maxTimeStamp, data, stepInMilliSeconds)
  return newArray

};

export const addOneHour = (timeString: string) => {
  // Input string time (24-hour format)

// Create a Date object with the current date
  const currentDate = new Date();

// Parse the input time string and set the hours and minutes of the Date object
  const [hours, minutes, seconds] = timeString.split(':');
  currentDate.setHours(parseInt(hours, 10), parseInt(minutes, 10), parseInt(seconds, 10));

// Add an hour to the Date object
  currentDate.setHours(currentDate.getHours() + 1);

// Get the updated time in the desired format
  const updatedTimeString = currentDate.toLocaleTimeString('fa-ir', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  console.log(updatedTimeString); // Output: 16:30
  return numericFunction.p2e(updatedTimeString)

}